import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import {
  FacilityCodeModel,
  OrganizationsService,
} from "../../../services/OrganizationsService";

export const useFacilityCodesQuery = (options?: {enabled?: boolean}) => {
  const {organizationId} = useParams<{organizationId: string}>();

  return useQuery(
    ["useFacilityCodes", organizationId],
    async () => {
      const {data} = await OrganizationsService.getOrganizationFacilityCodes(
        organizationId,
      );
      return data as {facilityCodes: FacilityCodeModel[]};
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!organizationId,
      ...options,
    },
  );
};
